import QuizStatuses from '@/constant/QuizStatuses'
import constants from '@/constant'
import utils from '@/util'
import { isColorLight, isContrast } from '@/utils/color.utils'
import renderCanvasBlocksUtils from '@/utils/renderCanvasBlocksUtils'

const { defaultQuestionTitle, defaultHeadingTitle } = constants

const isLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.slideActive.id && lastSlide && lastSlide.id === state.slideActive.id
}

const isStartPresentingFromLastSlide = (state) => {
  const { slides } = state.presentation
  const lastSlide = slides.length ? slides[slides.length - 1] : null
  return state.startPresentingFromSlideId === lastSlide.id
}

/**
 * @deprecated use slideActive getter inside slide.module instead
 */
const getSlideActive = (state) => {
  return state.slideActive
}

const isLobbyScreen = (state) => {
  return state.slideActive.quizStatus == QuizStatuses.LOBBY_SCREEN
}

const questionHasImageXLarge = (state) => {
  return !!(state.slideActive.image && state.slideActive.image.xLarge)
}

const isTextColourLight = (_, __, ___, rootGetters) => {
  const canViewThemeGallery = rootGetters['themeModule/canViewThemeGallery']
  const slideActive = rootGetters['slideModule/slideActive']
  if (canViewThemeGallery) return isColorLight(slideActive.textColour)
  return slideActive.textColour === '#ffffff'
}

const isQuestionImageEnabled = (state) => {
  let isEnable = state.slideActive.type === constants.SLIDE_TYPE.PICK_ANSWER && (
    state.slideActive.slideType === constants.SLIDE_TYPE.TYPE_ANSWER || !state.slideActive.slideType)

  // Always enable this feature (previously behind feature toggle)
  isEnable = isEnable || state.slideActive.slideType === constants.SLIDE_TYPE.PICK_IMAGE

  return isEnable
}

const isQuestionImageAndHasImageXLargeEnabled = (state) => {
  return questionHasImageXLarge(state) && isQuestionImageEnabled(state)
}

const isShowFullImageQuestion = (state) => {
  return state.slideActive.showFullImageQuestion && questionHasImageXLarge(state)
}

const hasSlideId = (state) => {
  return state.slideActive?.id ?? false
}

const isContentSlide = (_, getters) => {
  return getters['slideType/isContentSlide']
}

const currentSlideType = (state) => {
  return utils.getCorrectSlideTypeName(state.slideActive.type, state.slideActive.slideType)
}

const hasSlideTitle = (state) => {
  return hasSlideId(state) && state.slideActive?.title?.length > 0
}

const hasDefaultTitle = (state) => {
  const defaultTitles = [defaultHeadingTitle, defaultQuestionTitle]

  return hasSlideTitle(state) && defaultTitles.includes(state.slideActive.title.trim())
}

const slideTitle = (_, __, rootState) => {
  return rootState?.slideActive?.title
}
const hasDefaultCanvasBlockLayout = (state) => {
  if (!state.slideActive || !state.slideActive.canvasBlocks) return false

  return renderCanvasBlocksUtils.isDefaultCanvasBlocks(state.slideActive.canvasBlocks)
}

const isDefaultSlide = (state, getters) => {
  if (isContentSlide(state, getters)) {
    return hasDefaultCanvasBlockLayout(state)
  }

  return !hasSlideTitle(state) || hasDefaultTitle(state)
}
const isQuizSlideType = (state) => {
  const { id, type } = state.slideActive
  return id && type === 'pickAnswer'
}
const isSlideTitleEmpty = (state) => {
  return !state.slideActive.title || !state.slideActive.title.trim()
}

const isContrastEnough = (state) => {
  return isContrast(state.slideActive.textColour, state.slideActive.baseColour)
}

export default {
  isLastSlide,
  getSlideActive,
  isStartPresentingFromLastSlide,
  isLobbyScreen,
  questionHasImageXLarge,
  isTextColourLight,
  isQuestionImageEnabled,
  isShowFullImageQuestion,
  isQuestionImageAndHasImageXLargeEnabled,
  hasSlideId,
  isDefaultSlide,
  currentSlideType,
  hasSlideTitle,
  slideTitle,
  isQuizSlideType,
  isSlideTitleEmpty,
  isContrastEnough,
}
